const faqs = [
  {
    q: '五一黑料网是什么类型的网站？',
    a: '五一黑料网是一个专注于最新黑料吃瓜、今日黑料和瓜田爆料内幕的内容聚合平台，覆盖娱乐圈、网红圈、社会热点等多个领域的热点瓜事件与黑料视频，每日实时更新，为吃瓜网友提供一站式的黑料资讯服务。',
  },
  {
    q: '五一黑料入口和网站官网有什么区别？',
    a: '五一黑料入口和网站官网指向同一平台。由于黑料内容聚合站可能面临访问波动，我们会及时更新最新地址以确保用户畅通访问。建议您收藏当前页面或关注我们的社交媒体账号获取五一黑料最新入口信息。',
  },
  {
    q: '黑料吃瓜内容多久更新一次？',
    a: '我们的编辑团队7×24小时不间断追踪全网黑料热点，重大爆料事件通常在发生后30分钟内即可上线。日常内容每日更新200条以上，涵盖黑料吃瓜、今日黑料、热点瓜视频等多种类型，确保您不会错过任何一条料。',
  },
  {
    q: '如何向五一黑料网投稿或爆料？',
    a: '您可以通过页面上的"爆料投稿"区域联系我们。我们提供邮箱投稿（tips@wuyiheiliao.com）、微信爆料（wuyiheiliaotips）和在线提交三种方式。所有投稿信息严格保密，爆料一经采用将标注来源（可选择匿名）。',
  },
  {
    q: '五一黑料网的内容真实可靠吗？',
    a: '我们致力于提供真实可靠的黑料资讯。所有爆料内容均经过多方核实，标注信息来源。对于暂未完全证实的瓜料，我们会明确标注"待核实"标签。我们鼓励理性吃瓜，不支持恶意造谣和人身攻击。',
  },
  {
    q: '手机可以访问五一黑料网吗？',
    a: '可以。五一黑料网已全面适配移动端，无需下载APP，使用手机浏览器即可流畅访问。页面自适应屏幕尺寸，浏览体验与桌面端一致。建议将五一黑料入口添加至手机桌面，方便随时吃瓜。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          常见问题
        </h2>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <details
              key={idx}
              className="group bg-background-100 border border-secondary-200/60 rounded-xl overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 text-foreground-900 font-semibold text-base list-none">
                <span className="flex items-center gap-3">
                  <span className="w-7 h-7 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg text-sm font-bold flex-shrink-0">
                    {idx + 1}
                  </span>
                  <h3 className="text-base font-semibold">{faq.q}</h3>
                </span>
                <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6 pt-0">
                <p className="text-sm text-foreground-600 leading-relaxed pl-10">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}